'use client';

import Link from 'next/link';
import useTopStyle from '../../utils/useTopStyle';

// export const metadata = {
//     title: 'Legal — Cylerian',
//     description: 'Links to our legal documents: Terms, Privacy, Cookies, Licenses and more.',
// };

const docs = [
    { href: 'https://drive.google.com/file/d/1MzWALnFLtCgk6JVRvZX-d3HhtO-OBpaM/view?usp=sharing', title: 'Cylerian Case Study', desc: 'Ransomware Attack Prevention', type: 'whitepaper' },
    { href: 'https://drive.google.com/file/d/1i5CqWdv3jszRgYlJxCtxesVBbkyFMyaX/view?usp=sharing', title: 'Cylerian Exposure Management Overview', desc: 'Modern organizations face a crisis in exposure management.', type: 'datasheet' },
    { href: 'https://drive.google.com/file/d/1On2U0Rsa-5ipUxjOVwbC4dimvAkxYtIv/view?usp=sharing', title: 'Partner Overview', desc: 'Enterprise-grade cybersecurity in a unified platform.', type: 'datasheet' },
];

export default function LegalPage() {
    const ref = useTopStyle(72);

    return (
        <div className='legal-page'>
            <section
                className='company-hero'
                ref={ref}
            >
                <div className='container'>
                    <h2 className='title'>
                        Cylerian 
                        <span className='highlight'> Resources</span>
                    </h2>
                    <p className='text'>
                        Official resources for Cylerian. Select a resource below.
                    </p>
                </div>
            </section>

            <section className='feed resources-grid'> 
                <div className='grid'>
                    {docs.map((doc) => (
                        <section key={doc.href}>
                            <div className='inner-container' style={{ height: '280px' }}>
                                <p className='author'>{doc.type === 'whitepaper' ? 'WHITEPAPER' : 'DATA SHEET'}</p>
                                <p className='title' onClick={() => window.open(doc.href, '_blank')}>{doc.title}</p>
                                <p className='summary'>{doc.desc}</p>
                                <div className='read-more'>
                                    <div>
                                        <a href={doc.href} className='arrow-link' target='_blank' rel='noopener noreferrer'>View Document</a>
                                    </div>
                                </div>
                            </div>
                        </section>
                    ))}
                </div>
            </section>
        </div>
    );
}